import { render, staticRenderFns } from "./crumbs.vue?vue&type=template&id=509a5194&scoped=true"
import script from "./crumbs.vue?vue&type=script&lang=js"
export * from "./crumbs.vue?vue&type=script&lang=js"
import style0 from "./crumbs.vue?vue&type=style&index=0&id=509a5194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_65b20228bf64a20fbf49a510659098cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509a5194",
  null
  
)

export default component.exports